/* eslint-disable no-console */
class NewRelicMetricsHandler {
  addToTrace = attributes => this.safelyCallNewRelic(newrelic => newrelic.addToTrace(attributes));
  registerError = error => this.safelyCallNewRelic(newrelic => newrelic.noticeError(error));
  setPageName = name => this.safelyCallNewRelic(newrelic => newrelic.setPageViewName(name));
  registerEvent = (name, attributes) => this.safelyCallNewRelic(newrelic => newrelic.addPageAction(name, attributes));

  safelyCallNewRelic = (action) => {
    if (!window.newrelic) {
      console.warn('Could not call action on New Relic metrics handler (NewRelic script not loaded?)', action);
      return;
    }

    action(window.newrelic);
  }
}

export const newRelicMetricsHandler = new NewRelicMetricsHandler();

export const consoleMetricsHandler = {
  addToTrace: attributes => console.log('Adding attributes to trace', attributes),
  registerError: error => console.log('Error', error),
  setPageName: name => console.log('Setting page name', name),
  registerEvent: (name, attributes) => console.log('Registering page event', name, attributes)
};
